export default __webpack_public_path__ + "static/fall17-598b2630bd14e4168820b3086be1b27d.webp";